import React, { useEffect, useState } from 'react';

import ListColor from './ListColor';
import ListImage from './ListImage';

import ClientArea from '../pages/ClientArea';

interface ClientAreaAparrenceProps {
  corPrincial: string;
  setCorPrincial: (color: string) => void;
  corFundo: string;
  setCorFundo: (color: string) => void;
  imagemFundo: string;
  setImagemFundo: (color: string) => void;
}

const ClientAreaAparrence = ({
  corPrincial,
  setCorPrincial,
  corFundo,
  setCorFundo,
  imagemFundo,
  setImagemFundo,
}: ClientAreaAparrenceProps): JSX.Element => {
  const colors = [
    '#009F23',
    '#008BEF',
    '#FFC107',
    '#EA00EF',
    '#1300EF',
    '#DE0000',
  ];

  const [backgroundImagesList, setBackgroundImagesList] = useState([
    '42E14A06-39B1-4844-8F91-9DB83F1F561A.png',
    '90805E6D-F4DF-4D98-9A48-F0F8B7DBC298.png',
    '6682809E-54B7-43A3-B766-1A18105B96B4.png',
    '8AA1F9E9-20EA-4875-8002-FAB55C0ECE91.png',
    '6807A7A3-0D7A-48C6-968E-AAB68E57819C.png',
    '87FEF657-1985-4EF3-B474-285B638B5FD3.png',
    '5BA62401-89B0-4B4A-A72C-69219ECE5D93.png',
    '',
  ]);

  const addNewImage = (image: string): void => {
    if (image !== '' && !backgroundImagesList.includes(image)) {
      const updatedBackgroundImages = [...backgroundImagesList];
      updatedBackgroundImages[updatedBackgroundImages.length - 1] = image; // Atualiza o item na posição 5
      setBackgroundImagesList(updatedBackgroundImages);
    }
  };

  useEffect(() => {
    addNewImage(imagemFundo);
  }, [imagemFundo]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center">
        <div
          style={{
            height: '12.5rem',
            width: '22rem',
            borderRadius: '0.68rem',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            backgroundImage: imagemFundo
              ? `url('${process.env.REACT_APP_API_URL}/BackGroundImage/${imagemFundo}')`
              : 'none', // Define a imagem de fundo ou nenhum.
            backgroundColor:
              !imagemFundo && corFundo !== '' ? corFundo : 'transparent', // Aplica cor de fundo se não houver imagem.
            backgroundSize: imagemFundo ? '100% 100%' : 'auto', // Define o tamanho da imagem se houver imagem.
            backgroundPosition: 'center', // Posição da imagem.
            backgroundRepeat: 'no-repeat', // Impede repetição da imagem.
          }}
          className="overflow-hidden"
        >
          <ClientArea backgroundColor={corPrincial} />
        </div>
      </div>
      <div className="ms-3 mt-3">
        <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
          Cor Principal
        </span>
        <ListColor
          colors={colors}
          colorSelected={corPrincial}
          setColorSelected={setCorPrincial}
          positionShow="18rem"
          positionShowTop="0rem"
          showColorSelected
        />
      </div>
      <div className="ps-3 t-3 w-100">
        <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
          Plano de Fundo Principal
        </span>
        <div className="mb-3">
          <ListImage
            backgroundImages={backgroundImagesList}
            backgroundColor={corFundo}
            setBackgroundColor={setCorFundo}
            backgroundImage={imagemFundo}
            setBackgroundImage={setImagemFundo}
            positionShow="28rem"
            addNewImage={addNewImage}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientAreaAparrence;
